import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';

export interface SortModel {
  label: string;
  field: string | string[];
  ascending: boolean;
}

@Component({
  selector: 'app-sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SortComponent implements OnInit {
  @Input()
  public get sort(): SortModel {
    return this._sort;
  }
  public set sort(value: SortModel) {
    this._sort = value;
    this.changeDetectorRef.markForCheck();
  }
  private _sort: SortModel;

  @Input()
  sortOptions: SortModel[] = [];

  @Output()
  sortChange = new EventEmitter<SortModel>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  handleSort(option: SortModel) {
    this.sortChange.emit(option);
  }

}
